export default __webpack_public_path__ + "static/media/skilvul.860106f8.png";